import React from "react";
import {createUseStyles} from "react-jss";

//https://github.com/mui-org/material-ui/blob/next/packages/material-ui-icons/src/Send.js
//https://github.com/mui-org/material-ui/blob/85dd137d58b50a32015e98382f0c8d92be6ffcc1/packages/material-ui/src/SvgIcon/SvgIcon.js#L55

const useStyles = createUseStyles({
    svg: {
        fill: "currentColor",
        width: "1em",
        height: "1em",
        display: "inline-block",
        flexShrink: 0,
        userSelect: "none",
        fontSize: "1.5rem"
    }
});

export default function SendIcon(){
    const classes = useStyles();
    return (
        <svg className={classes.svg} viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" /></svg>
    );
}